<template>
  <div class="clearfix">
    <div class="clear hei40"></div>
    <div class="con-width-1200 content">
      <div class="public-title clearfix pos-rel">
        <h2 class="pos-rel course">HospitalNewspaper</h2>
        <h1 class="pos-abs">院报</h1>
        <h3 class="pos-abs">简介，历史</h3>
        <div class="catage clearfix pos-abs">您所在位置：首页 > 院报 > 列表</div>
      </div>

      




      <ul class="article-list rad5 clearfix">
        <li class="clearfix pos-rel" v-for="(item,index) in dataList" :key="index" @click="jump(item.id)">
          <h1 class="text-wid">{{item.title}}</h1>
          <span class="intro">
            {{item.description}}
          </span>
          <span class="data pos-abs">{{item.releaseDate}}</span>
        </li>
      </ul>
    </div>

    <div class="page-list clearfix">
      <a href="#" class="focus">1</a>
      <a href="#" class="">2</a>
    </div>
    <div class="clear hei20"></div>
  </div>
</template>

<script>
  import _http from "../httpService"

  export default {
    name: "HospitalSummedup",
    props: {
      msg: String
    },
    components: {
    },
    data() {
      return {
        dataList:[],
        imgList:[
          {img:require("../assets/images/img0.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师内科学系主任 主任医师 博士研究生导师内科学系主任 主任医师 博士研究生导师内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img1.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img2.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img0.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img1.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img2.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img0.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img1.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img2.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img0.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img1.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img2.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img0.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img1.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img2.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img0.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img1.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
          {img:require("../assets/images/img2.jpg"), name:'姓名', desc:'内科学系主任 主任医师 博士研究生导师'},
        ],
        isDisable: false,
        name: "",
        mobile: "",
        content: ""
      };
    },
    filters: {
      ellipsis(value) {
        if (!value) return ''
        if (value.length > 30) {
          return value.slice(0, 30) + '...'
        }
        return value
      }
    },
    methods:{
      jump:function(id){
        this.$router.push({ path: "/Article/" + id });
      },
    },
    created() {
      // 初始化加载栏目等数据
      _http
          .get(
              "/content/jcContent/list?channelCode=HospitalNewspaper"
          )
          .then(resp => {
            if(resp.data.success)
              this.dataList = resp.data.result.records
          })
          .catch(error => console.log(error))
          .finally(() => (this.loading = false));
    }
  }
</script>
<style lang="scss" scoped>
  @import "../assets/css/public.css";
  @import "../assets/css/public.scss";
</style>
